import { DATA } from '../game/data';
import { AIRPLANE_DATA } from '../game/data/airplaneData';
import { AIRPORT_DATA, AIRPORT_LIST } from '../game/data/airportData';
import { LOUNGE_DATA } from '../game/data/loungeData';
import { MANAGER_DATA } from '../game/data/managerData';
import { formatNumber, niceRounding } from '../game/helpers';

export function balancePrintTotalBuyPrice() {
  // DATA.advance();
  // DATA.advance();
  // DATA.advance();
  // DATA.advance();

  console.log('================= Airplane prices =================');
  let allAirplanesSum = 0;
  for (let i = 0; i < AIRPLANE_DATA.MAX_AIRPLANES - AIRPLANE_DATA.DEFAULT_AIRPLANES; i++) {
    const price = AIRPLANE_DATA.priceFn(i);
    console.log(price);
    allAirplanesSum += price;
  }
  console.log('To buy all airplanes you need', formatNumber(allAirplanesSum));

  console.log('================= Airports =================');
  for (let i = 0; i < DATA.airports.length; i++) {
    const airportPrice = DATA.airports[i].airportPrice;
    const managerPrice = DATA.airports[i].managerPrice;
    const loungePrice = DATA.airports[i].loungePrice;
    console.log(i, 'Airport', airportPrice, 'Manager', managerPrice, 'Lounge', loungePrice);
  }
}
